import React, { memo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, Typography, Divider, Rating, Icon } from 'investira.react.components';
import Impacto from '../../_components/Impacto';

const AvaliacoesOutputRespostasAvaliacao = memo(props => {
  const { data, variant = null, nota, peso, aliasQuestionId } = props;

  const xPlaceholderResposta = 'Resposta não informada pelo gestor.';

  const getNormalizedText = pValue => {
    const xValue = String(pValue ?? '').trim();
    return validators.isEmpty(xValue) ? null : xValue;
  };

  const getFirstText = (...pValues) => pValues.map(getNormalizedText).find(Boolean) || null;

  const xRespostaGestor = getFirstText(
    data?.resposta_gestor,
    data?.respostaGestor,
    data?.resposta,
    data?.resposta_texto,
    data?.answer
  );

  const xJustificativa = getFirstText(
    data?.justificativa,
    data?.justificativa_gestor,
    data?.justificativaGestor,
    data?.markdown,
    data?.comentario
  );

  const hasJustificativa = Boolean(xJustificativa);
  const xRespostaExibida = xRespostaGestor || xPlaceholderResposta;
  const xNotaGestor = Number(data?.nota_gestor);
  const hasNotaGestor = Number.isFinite(xNotaGestor);
  const hasNotaFinal = Number.isFinite(Number(nota));
  const hasAlteracaoNotaByValue = hasNotaGestor && hasNotaFinal && xNotaGestor !== Number(nota);
  const xHasAlteracaoNota =
    typeof data?.houve_alteracao_nota === 'boolean'
      ? data.houve_alteracao_nota
      : hasAlteracaoNotaByValue;

  return (
    <Stack>
      <Stack>
        <Typography color="textPrimary" variant="body1" sx={{ fontWeight: 600 }} gutterBottom>
          {aliasQuestionId} {data.questao}
        </Typography>
      </Stack>
      <Stack
        sx={{
          pl: 3,
          borderLeft: '4px solid',
          borderColor:
            nota < 2
              ? 'error.main'
              : nota < 3.5
              ? 'warning.main'
              : nota < 4
              ? 'info.main'
              : 'primary.main',
          px: 2
        }}
        gap={1}>
        {!validators.isNull(nota) && (
          <>
            <Stack gap={3} direction="row" alignItems="baseline" justifyContent="space-between">
              <Stack direction="row" gap={2} alignItems="baseline">
                <Typography color="textPrimary" variant="h4">
                  {Number.isInteger(nota) ? `${nota}.0` : nota}
                </Typography>
                <Rating name="read-only" value={Number(nota)} max={4} readOnly />
              </Stack>
              {!validators.isNull(peso) && (
                <Impacto label="Peso" defaultValue={peso} variant="readValue" />
              )}
            </Stack>
            <Divider />
          </>
        )}

        {validators.isNull(variant) && (
          <>
            <Stack direction="row" gap={4}>
              <Stack>
                <Stack direction="row" gap={4}>
                  <Stack gap={1}>
                    <Typography color="textPrimary" variant="caption">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <Divider />
          </>
        )}

        {variant === 'justificativa' && (
          <>
            <Stack direction="row" gap={4} flexGrow={1}>
              {/* <Stack flexGrow={1}> */}
              <Stack gap={2} flexGrow={1}>
                {hasJustificativa && (
                  <Stack
                    direction="row"
                    gap={1}
                    alignItems="center"
                    sx={{
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      backgroundColor: xHasAlteracaoNota ? 'warning.light' : 'info.main'
                    }}>
                    <Icon iconName="warning" color="secondary" size={14} />
                    <Typography color="secondary.dark" variant="caption" sx={{ fontWeight: 500 }}>
                      {xHasAlteracaoNota
                        ? 'Houve alteração da nota durante a avaliação da entidade'
                        : 'Nota mantida após avaliação da entidade, com justificativa registrada'}
                    </Typography>
                  </Stack>
                )}

                <Stack gap={1}>
                  <Typography color="textSecondary" variant="caption">
                    Resposta do gestor
                  </Typography>
                  <Typography color="textPrimary" variant="caption">
                    {xRespostaExibida}
                  </Typography>
                </Stack>

                {hasJustificativa && (
                  <Stack gap={1}>
                    <Typography color="textSecondary" variant="caption">
                      Justificativa do avaliador
                    </Typography>
                    <Typography color="textPrimary" variant="caption">
                      {xJustificativa}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
            {/* </Stack> */}
            <Divider />
          </>
        )}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesOutputRespostasAvaliacao;
